import InstantSearchProvider, {
  type InstantSearchConfig,
  type InstantSearchInitialState,
} from './provider/instantSearchProvider';
import InstantSearchHeader from './instantSearchHeader';
import InstantSearchResults from './instantSearchResults';
import InstantSearchStatus, {
  type InstantSearchStatusProps,
} from './instantSearchStatus';
import NoResultsBoundary from './noResultsBoundary';
import VehicleSearchBanner, {
  type VehicleSearchBannerProps,
} from '@components/vehicle_search/vehicleSearchBanner';
import type { HasMotabilityState } from '@javascript/types/InstantSearch';

type InstantSearchContainerProps = {
  initialState: InstantSearchInitialState | null;
  instantSearchConfig: InstantSearchConfig;
} & VehicleSearchBannerProps &
  InstantSearchStatusProps &
  HasMotabilityState;

const InstantSearchContainer = (props: InstantSearchContainerProps) => {
  return (
    <InstantSearchProvider
      {...props.instantSearchConfig}
      initialState={props.initialState}
      syncURL
    >
      <InstantSearchHeader isMotability={props.isMotability} />
      <InstantSearchStatus
        branches={props.branches}
        isMotability={props.isMotability}
      />
      <div className="ac-search__banner js-off--hide ch-mb--1 sm:ch-mt--n1">
        <div className="ch-container">
          <div className="ac-promo__wrapper">
            <VehicleSearchBanner bannerProps={props.bannerProps} />
          </div>
        </div>
      </div>
      <div className="ch-container">
        <NoResultsBoundary branches={props.branches}>
          <InstantSearchResults />
        </NoResultsBoundary>
      </div>
    </InstantSearchProvider>
  );
};

export default InstantSearchContainer;
